export default __webpack_public_path__ + "static/media/volt-solar-bg.49113f1d.jpeg";